<template>
  <div class="container-fluid">
    <h5 class="mb-2">Text Input</h5>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Match Text</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="question.configTextInput" v-model="question.configTextInput.matchText"/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Text to match</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-if="question.configTextInput" :disabled="!question.configTextInput.matchText" v-model="question.configTextInput.textToMatch" 
          placeholder="Text to match..."/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Case Sensitive</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="question.configTextInput" :disabled="!question.configTextInput.matchText" v-model="question.configTextInput.caseSensitive"/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Placeholder text</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-input v-if="question.configTextInput" label="Question" placeholder="Placeholder text..." :content.sync="question.configTextInput.placeholderText" class="w-full" />
      </div>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "QuestionConfigTextInput",
  components: {},
  directives: {
  },
  props: ['question'],
  data() {
    return {
    };
  },
  mounted() {
    console.log(this.question.configTextInput);
    
    if (!this.question.configTextInput || this.question.configTextInput === null) {
        this.question.configTextInput = {
            matchText: false,
            caseSensitive: false,
            textToMatch: '',
            placeholderText: ''
        };
    }
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>